import { Component, Input } from '@angular/core';
import { ChannelFormData, FieldRule, LinkedSurvey, SkuRule } from '../../channels.model';

@Component({
  selector: 'app-channel-impact-preview-tab',
  standalone: false,
  templateUrl: './channel-impact-preview-tab.component.html',
  styleUrl: './channel-impact-preview-tab.component.scss'
})
export class ChannelImpactPreviewTabComponent {
  @Input() formData!: ChannelFormData;
  @Input() fieldRules: FieldRule[] = [];
  @Input() linkedSurveys: LinkedSurvey[] = [];
  @Input() skuRules: SkuRule[] = [];

  get totalConfigItems(): number {
    return this.fieldRules.length + this.linkedSurveys.length + this.skuRules.length;
  }
}
